import AddTournamentModule from '@/modules/league-management/add-tour';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/dashboard/fantasy/league-management/add-tour'
)({
  component: AddTournamentPage,
});

function AddTournamentPage() {
  return <AddTournamentModule />;
}
